module.exports = __webpack_public_path__ + "static/media/Online connection-rafiki.62a5dbd7.svg";